import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Camada_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 204 41",
	style: { enableBackground: "new 0 0 204 41" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#FFFFFF;}\n	.st1{fill:#3E849E;}\n"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M53.1,33.3v-22c0-2.5,1.9-4,3.9-4c1.7,0,3,0.6,3.8,2l10.1,17.3V7.8h5.2v22c0,2.5-1.9,4-3.9,4 c-1.6,0-3-0.6-3.9-2L58.3,14.4v18.9H53.1L53.1,33.3z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M80.4,23.7c0-5.4,3.9-9.9,9.7-9.9s9.4,4.4,9.4,9.5v1.6H85.6c0.4,2.5,2.3,4.2,5,4.2c2.1,0,3.8-1,4.6-2.7 l4.1,2.1c-1.6,3.4-4.7,5.3-8.7,5.3C84.8,33.8,80.4,29.7,80.4,23.7z M94.2,21.9c-0.2-1.9-1.8-3.4-4.1-3.4s-3.9,1.5-4.3,3.4H94.2 L94.2,21.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M102.3,23.8c0-5.4,4.4-9.9,10.2-9.9s10.2,4.5,10.2,9.9s-4.4,9.9-10.2,9.9S102.3,29.3,102.3,23.8z M117.3,23.9 c0-2.6-2.1-4.9-4.8-4.9s-4.8,2.2-4.8,4.9s2,4.9,4.8,4.9S117.3,26.5,117.3,23.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M127.2,33.3V10.3c0-1.5,0.6-2.4,2.4-2.4h14.4v2.3h-14.4v10.2h13.6v2.3h-13.6v10.5L127.2,33.3L127.2,33.3z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M146.8,24c0-5.2,4.1-9.6,9.6-9.6s9.7,4.2,9.7,9.6v9.2h-2.2V29c-1.4,2.8-4.2,4.7-7.7,4.7 C150.8,33.7,146.8,29.3,146.8,24z M163.8,24.1c0-4-3.2-7.4-7.3-7.4s-7.3,3.3-7.3,7.4s3.2,7.4,7.3,7.4S163.8,28.1,163.8,24.1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M170.4,24.1c0-5.3,4.3-9.6,9.4-9.6c3.3,0,6.2,1.4,7.9,4.6l-2,1.1c-1.3-2.4-3.5-3.5-5.9-3.5c-3.8,0-7,3.3-7,7.4 s3.2,7.4,7,7.4c2.5,0,4.6-1.1,5.9-3.4l2,1.1c-1.7,3.1-4.7,4.5-7.9,4.5C174.7,33.7,170.4,29.4,170.4,24.1L170.4,24.1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M193.6,27.3V17h-3.9v-2.1h3.9V10h2.4v4.9h7.5V17h-7.5v10.2c0,2.7,1.6,4.3,4,4.3c1.3,0,2.6-0.5,3.5-1.2v2.3 c-0.9,0.7-2.3,1.2-3.7,1.2C195.9,33.7,193.6,31.2,193.6,27.3L193.6,27.3z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M35.9,0H5.1c-0.7,0-1.4,0.1-2,0.4C1.3,1.2,0,3,0,5.1v30.8l0,0V41h35.9c2.1,0,3.9-1.3,4.7-3.1 c0.3-0.6,0.4-1.3,0.4-2l0,0V5.1l0,0V0C41,0,35.9,0,35.9,0z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M23.5,29.7c-3.4,0-6.4-1.9-7.9-4.6h7.9V22h-9.1c-0.1-0.5-0.2-1-0.2-1.5s0.1-1,0.2-1.5h9.1v-3.1h-7.9 c1.6-2.8,4.5-4.6,7.9-4.6c2.9,0,5.5,1.3,7.1,3.4l2.2-2.2c-2.2-2.6-5.6-4.3-9.3-4.3c-5.2,0-9.6,3.2-11.4,7.7h-4v3.1h3.2 c-0.1,0.5-0.2,1-0.2,1.5s0.1,1,0.1,1.5H8.1v3.1h4c1.8,4.5,6.2,7.7,11.4,7.7c3.7,0,7.1-1.7,9.3-4.3l-2.2-2.2 C29,28.4,26.4,29.7,23.5,29.7L23.5,29.7z"
		})] })
	]
});
export default SvgLogo;
